import React from 'react'
import "./skill.css";
export default function Skill({skill,color}) {
    return (
        <div className="skill-tag">
            <span style={{background:color}} className="skill-circle"></span> {skill}
        </div>
    )
}
